<template>
  <div class="audit-auth-owner-undo-container">
    <!-- 顶部状态栏 -->
    <div class="page-header">
      <div class="header-left">
        <h2 class="page-title">认证审核详情</h2>
        <el-tag v-if="auditAuthOwnerUndoInfo.state === '10000'" type="warning" size="medium">待审核</el-tag>
        <el-tag v-else-if="auditAuthOwnerUndoInfo.state === '12000'" type="success" size="medium">已通过</el-tag>
        <el-tag v-else-if="auditAuthOwnerUndoInfo.state === '13000'" type="danger" size="medium">已拒绝</el-tag>
      </div>
      <el-button icon="el-icon-back" @click="goBack">返回列表</el-button>
    </div>

    <!-- 对比信息（核心：认证人 vs 业主/房屋） -->
    <el-card class="box-card compare-card">
      <div slot="header" class="card-header">
        <span class="card-title"><i class="el-icon-sort"></i> 信息对比</span>
        <span class="card-tip">认证人申请信息 vs 系统已有信息</span>
      </div>
      <div v-if="compareLoading" style="text-align:center;padding:40px;color:#909399">
        <i class="el-icon-loading"></i> 正在加载对比数据...
      </div>
      <template v-else>
        <el-table :data="[compareData]" border :show-header="false" class="compare-table">
          <el-table-column width="120" label="对比项" class-name="compare-label-col">
            <template><div class="compare-label">姓名</div></template>
          </el-table-column>
          <el-table-column width="220" label="认证人信息" class-name="compare-app-col">
            <template><div class="compare-value app-value">{{ auditAuthOwnerUndoInfo.appUserName || '-' }}</div></template>
          </el-table-column>
          <el-table-column width="220" label="系统信息" class-name="compare-sys-col">
            <template>
              <div class="compare-value sys-value" :class="{'match': compareResult.nameMatch, 'mismatch': !compareResult.nameMatch && compareResult.nameMatch !== null}">
                {{ isFamilyMember ? '—' : (compareResult.sysOwnerName || '未绑定业主') }}
                <i v-if="!isFamilyMember && compareResult.nameMatch === true" class="el-icon-check matched-icon"></i>
                <i v-if="!isFamilyMember && compareResult.nameMatch === false" class="el-icon-close mismatched-icon"></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="对比结果">
            <template>
              <template v-if="!isFamilyMember">
                <el-tag v-if="compareResult.nameMatch === true" type="success" size="small">姓名匹配</el-tag>
                <el-tag v-else-if="compareResult.nameMatch === false" type="danger" size="small">姓名不一致</el-tag>
                <span v-else class="text-muted">—</span>
              </template>
              <span v-else class="text-muted">—</span>
            </template>
          </el-table-column>
        </el-table>
        <el-table :data="[compareData]" border :show-header="false" class="compare-table">
          <el-table-column width="120" label="对比项" class-name="compare-label-col">
            <template><div class="compare-label">手机号</div></template>
          </el-table-column>
          <el-table-column width="220" label="认证人信息" class-name="compare-app-col">
            <template><div class="compare-value app-value">{{ auditAuthOwnerUndoInfo.link || '-' }}</div></template>
          </el-table-column>
          <el-table-column width="220" label="系统信息" class-name="compare-sys-col">
            <template>
              <div class="compare-value sys-value" :class="{'match': compareResult.linkMatch, 'mismatch': !compareResult.linkMatch && compareResult.linkMatch !== null}">
                {{ isFamilyMember ? '—' : (compareResult.sysOwnerLink || '—') }}
                <i v-if="!isFamilyMember && compareResult.linkMatch === true" class="el-icon-check matched-icon"></i>
                <i v-if="!isFamilyMember && compareResult.linkMatch === false" class="el-icon-close mismatched-icon"></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="对比结果">
            <template>
              <template v-if="!isFamilyMember">
                <el-tag v-if="compareResult.linkMatch === true" type="success" size="small">号码匹配</el-tag>
                <el-tag v-else-if="compareResult.linkMatch === false" type="danger" size="small">号码不一致</el-tag>
                <span v-else class="text-muted">—</span>
              </template>
              <span v-else class="text-muted">—</span>
            </template>
          </el-table-column>
        </el-table>
        <el-table :data="[compareData]" border :show-header="false" class="compare-table">
          <el-table-column width="120" label="对比项" class-name="compare-label-col">
            <template><div class="compare-label">身份证</div></template>
          </el-table-column>
          <el-table-column width="220" label="认证人信息" class-name="compare-app-col">
            <template><div class="compare-value app-value">{{ auditAuthOwnerUndoInfo.idCard || '-' }}</div></template>
          </el-table-column>
          <el-table-column width="220" label="系统信息" class-name="compare-sys-col">
            <template>
              <div class="compare-value sys-value" :class="{'match': compareResult.idCardMatch, 'mismatch': !compareResult.idCardMatch && compareResult.idCardMatch !== null}">
                {{ isFamilyMember ? '—' : (compareResult.sysOwnerIdCard || '—') }}
                <i v-if="!isFamilyMember && compareResult.idCardMatch === true" class="el-icon-check matched-icon"></i>
                <i v-if="!isFamilyMember && compareResult.idCardMatch === false" class="el-icon-close mismatched-icon"></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="对比结果">
            <template>
              <template v-if="!isFamilyMember">
                <el-tag v-if="compareResult.idCardMatch === true" type="success" size="small">身份证匹配</el-tag>
                <el-tag v-else-if="compareResult.idCardMatch === false" type="danger" size="small">身份证不一致</el-tag>
                <span v-else class="text-muted">—</span>
              </template>
              <span v-else class="text-muted">—</span>
            </template>
          </el-table-column>
        </el-table>
      <el-table :data="[compareData]" border :show-header="false" class="compare-table">
        <el-table-column width="120" label="对比项" class-name="compare-label-col">
          <template><div class="compare-label">房屋</div></template>
        </el-table-column>
        <el-table-column width="220" label="认证人信息" class-name="compare-app-col">
          <template><div class="compare-value app-value">{{ compareResult.appRoomName || '—' }}</div></template>
        </el-table-column>
        <el-table-column width="220" label="系统信息" class-name="compare-sys-col">
          <template>
            <div class="compare-value sys-value" :class="{'match': compareResult.roomMatch, 'mismatch': !compareResult.roomMatch && compareResult.roomMatch !== null}">
              {{ compareResult.sysRoomName || '未绑定房屋' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="对比结果">
          <template>
            <span class="text-muted">—</span>
          </template>
        </el-table-column>
      </el-table>
      <el-table :data="[compareData]" border :show-header="false" class="compare-table">
        <el-table-column width="120" label="对比项" class-name="compare-label-col">
          <template><div class="compare-label">身份角色</div></template>
        </el-table-column>
        <el-table-column width="220" label="认证人信息" class-name="compare-app-col">
          <template><div class="compare-value app-value">{{ auditAuthOwnerUndoInfo.ownerTypeCdName || '-' }}</div></template>
        </el-table-column>
        <el-table-column width="220" label="绑定业主" class-name="compare-sys-col">
          <template><div class="compare-value sys-value">{{ auditAuthOwnerUndoInfo.ownerName || '—' }}</div></template>
        </el-table-column>
        <el-table-column>
          <template><span class="text-muted">—</span></template>
        </el-table-column>
      </el-table>
      </template>
    </el-card>

    <!-- 房屋信息 -->
    <el-card class="box-card" v-if="auditAuthOwnerUndoInfo.roomId && auditAuthOwnerUndoInfo.room && auditAuthOwnerUndoInfo.room.roomName">
      <div slot="header" class="card-header">
        <span class="card-title"><i class="el-icon-house"></i> 房屋信息</span>
      </div>
      <el-row :gutter="24">
        <el-col :span="8" v-for="item in roomInfoList" :key="item.label">
          <div class="info-item">
            <div class="info-label">{{ item.label }}</div>
            <div class="info-value">{{ item.value }}</div>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <!-- 车位认证信息 -->
    <el-card class="box-card" v-if="auditAuthOwnerUndoInfo.psId || auditAuthOwnerUndoInfo.carNum || auditAuthOwnerUndoInfo.psName">
      <div slot="header" class="card-header">
        <span class="card-title"><i class="el-icon-truck"></i> 车位认证信息</span>
      </div>
      <el-row :gutter="24">
        <el-col :span="8" v-if="auditAuthOwnerUndoInfo.carNum">
          <div class="info-item">
            <div class="info-label">车牌号</div>
            <div class="info-value highlight">{{ auditAuthOwnerUndoInfo.carNum }}</div>
          </div>
        </el-col>
        <el-col :span="8" v-if="auditAuthOwnerUndoInfo.psName">
          <div class="info-item">
            <div class="info-label">车位</div>
            <div class="info-value">{{ auditAuthOwnerUndoInfo.psName }}</div>
          </div>
        </el-col>
        <el-col :span="8" v-if="auditAuthOwnerUndoInfo.psId">
          <div class="info-item">
            <div class="info-label">车位ID</div>
            <div class="info-value text-mono">{{ auditAuthOwnerUndoInfo.psId }}</div>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <!-- 房屋已有成员 -->
    <el-card class="box-card" v-if="auditAuthOwnerUndoInfo.roomId">
      <div slot="header" class="card-header">
        <span class="card-title"><i class="el-icon-user"></i> 房屋已有成员</span>
        <span class="card-tip">当前该房屋关联的业主信息</span>
      </div>
      <el-table :data="auditAuthOwnerUndoInfo.owners" border stripe>
        <el-table-column prop="url" label="头像" width="80" align="center">
          <template slot-scope="scope">
            <el-image
              style="width: 48px; height: 48px; border-radius: 50%;"
              :src="scope.row.url || '/img/noPhoto.jpg'"
              :preview-src-list="[scope.row.url]"
              fit="cover"
            />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="姓名" align="center" />
        <el-table-column prop="link" label="联系方式" align="center" width="140" />
        <el-table-column prop="idCard" label="身份证" align="center" width="200">
          <template slot-scope="scope">{{ scope.row.idCard || '-' }}</template>
        </el-table-column>
        <el-table-column label="类型" align="center" width="100">
          <template slot-scope="scope">
            <el-tag size="small" :type="scope.row.ownerTypeCd === '1001' ? 'primary' : 'info'">
              {{ scope.row.ownerTypeCd === '1001' ? '业主' : '成员' }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 证明图片 -->
    <el-card class="box-card" v-if="auditAuthOwnerUndoInfo.photoUrls.length > 0">
      <div slot="header" class="card-header">
        <span class="card-title"><i class="el-icon-picture-outline"></i> 认证证明材料</span>
        <span class="card-tip">共 {{ auditAuthOwnerUndoInfo.photoUrls.length }} 张</span>
      </div>
      <div class="photo-grid">
        <el-image
          v-for="(url, index) in auditAuthOwnerUndoInfo.photoUrls"
          :key="index"
          class="photo-item"
          :src="url"
          :preview-src-list="auditAuthOwnerUndoInfo.photoUrls"
          fit="cover"
        />
      </div>
    </el-card>

    <!-- 审核操作（仅待审核状态显示） -->
    <el-card class="box-card audit-card" v-if="auditAuthOwnerUndoInfo.state === '10000'">
      <div slot="header" class="card-header">
        <span class="card-title"><i class="el-icon-edit-outline"></i> 审核操作</span>
      </div>
      <el-form label-width="100px" size="medium">
        <el-form-item label="审核结果">
          <el-radio-group v-model="auditAuthOwnerUndoInfo.audit.state" @change="onAuditStateChange">
            <el-radio-button label="1100">
              <i class="el-icon-check"></i> 同意通过
            </el-radio-button>
            <el-radio-button label="1200">
              <i class="el-icon-close"></i> 拒绝驳回
            </el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审核说明">
          <el-input
            type="textarea"
            v-model="auditAuthOwnerUndoInfo.audit.remark"
            :placeholder="auditAuthOwnerUndoInfo.audit.state === '1200' ? '请填写拒绝原因...' : '审核说明...'"
            :rows="4"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="medium" @click="auditSubmit">
            <i class="el-icon-finished"></i> 提交审核
          </el-button>
          <el-button size="medium" @click="goBack">取消</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 已审核结果显示 -->
    <el-card class="box-card audit-result-card" v-if="auditAuthOwnerUndoInfo.state && auditAuthOwnerUndoInfo.state !== '10000'">
      <div slot="header" class="card-header">
        <span class="card-title"><i class="el-icon-document-checked"></i> 审核结果</span>
      </div>
      <div class="audit-result">
        <div class="result-status">
          <div class="result-icon" :class="auditAuthOwnerUndoInfo.state === '12000' ? 'success' : 'fail'">
            <i :class="auditAuthOwnerUndoInfo.state === '12000' ? 'el-icon-circle-check' : 'el-icon-circle-close'" />
          </div>
          <div class="result-text">
            <h3>{{ auditAuthOwnerUndoInfo.state === '12000' ? '审核已通过' : '审核已拒绝' }}</h3>
            <p class="result-remark">{{ auditAuthOwnerUndoInfo.audit.remark || '无备注' }}</p>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { getRoomInfo, getOwnerList, auditAuthOwner } from '@/api/owner/auditAuthOwnerUndoApi'

function getFileBaseUrl() {
  return window.location.origin + '/callComponent/download/getFile/file'
}

export default {
  name: 'AuditAuthOwnerUndoList',
  data() {
    return {
      compareLoading: false,
      compareResult: {
        sysOwnerName: null,
        sysOwnerLink: null,
        sysOwnerIdCard: null,
        sysRoomName: null,
        appRoomName: '—',
        nameMatch: null,
        linkMatch: null,
        idCardMatch: null,
        roomMatch: null
      },
      auditAuthOwnerUndoInfo: {
        room: {},
        roomId: '',
        owners: [],
        appUserName: '',
        link: '',
        idCard: '',
        carNum: '',
        psId: '',
        psName: '',
        ownerName: '',
        ownerTypeCdName: '',
        photoUrls: [],
        state: '',
        audit: {
          state: '',
          remark: '',
          appUserId: ''
        }
      }
    }
  },
  computed: {
    isFamilyMember() {
      const type = this.auditAuthOwnerUndoInfo.ownerTypeCdName || ''
      return type === '户员' || type === '家庭成员'
    },
    roomInfoList() {
      const r = this.auditAuthOwnerUndoInfo.room
      if (!r || !r.roomName) return []
      return [
        { label: '房间号', value: r.roomName || '-' },
        { label: '建筑面积', value: r.builtUpArea ? r.builtUpArea + ' m²' : '-' },
        { label: '房屋类型', value: r.roomSubTypeName || '-' },
        { label: '房屋状态', value: r.stateName || '-' },
        { label: '业主姓名', value: r.ownerName || '未绑定' },
        { label: '业主电话', value: r.link || '-' }
      ]
    },
    compareData() {
      return {}  // 占位对象，table 需要 data 属性
    }
  },
  watch: {
    // 监听路由参数变化（首次进入 + 从列表跳转），立即执行
    '$route.query': {
      immediate: true,
      handler(newQuery) {
        // 同一页面内切换审核对象时，如果 query 有变化则重新加载
        if (!newQuery.appUserId) return
        this.initData()
      }
    }
  },
  created() {
    // watch immediate 已经覆盖首次加载，created 不再重复调用
  },
  methods: {
    initData() {
      // 重置对比数据
      this.auditAuthOwnerUndoInfo.room = {}
      this.auditAuthOwnerUndoInfo.owners = []

      // 从路由参数获取认证人信息
      this.auditAuthOwnerUndoInfo.audit.appUserId = this.$route.query.appUserId
      this.auditAuthOwnerUndoInfo.roomId = this.$route.query.roomId || ''
      this.auditAuthOwnerUndoInfo.appUserName = this.$route.query.appUserName || ''
      this.auditAuthOwnerUndoInfo.link = this.$route.query.link || ''
      this.auditAuthOwnerUndoInfo.idCard = this.$route.query.idCard || ''
      this.auditAuthOwnerUndoInfo.ownerTypeCdName = this.$route.query.ownerTypeCdName || ''
      this.auditAuthOwnerUndoInfo.ownerName = this.$route.query.ownerName || ''
      this.auditAuthOwnerUndoInfo.state = this.$route.query.state || ''

      const remark = this.$route.query.remark || ''
      this.parseRemark(remark)

      if (this.auditAuthOwnerUndoInfo.roomId) {
        this._doLoadCompareData()
      }
    },

    async _doLoadCompareData() {
      this.compareLoading = true
      const roomId = this.auditAuthOwnerUndoInfo.roomId
      console.log('[audit] 开始加载对比数据 roomId=', roomId)
      try {
        const [roomRes, ownerRes] = await Promise.all([
          getRoomInfo({ page: 1, row: 1, roomId, communityId: getCommunityId() }),
          getOwnerList({ page: 1, row: 100, roomId, communityId: getCommunityId() })
        ])

        // 赋值房间数据（兼容 res.rooms 和 res.data 两种返回格式）
        const rooms = roomRes.rooms || roomRes.data || []
        console.log('[audit] 房间数据返回:', roomRes.code, roomRes.data, 'rooms=', rooms.length)
        if (rooms.length > 0) {
          this.$set(this.auditAuthOwnerUndoInfo, 'room', rooms[0])
          console.log('[audit] room 已赋值 ownerName=', rooms[0].ownerName)
        }

        // 赋值业主数据
        const list = ownerRes.owners || ownerRes.data || []
        console.log('[audit] 业主数据返回:', ownerRes.code, 'list=', list.length, list.map(o => o.name))
        this.$set(this.auditAuthOwnerUndoInfo, 'owners', Array.isArray(list) ? list : [])

        // 手动更新对比结果（绕过 computed 可能的不更新问题）
        this._updateCompareResult()
      } catch (error) {
        console.error('[audit] 加载对比数据失败:', error)
      } finally {
        await this.$nextTick()
        this.compareLoading = false
        console.log('[audit] 对比数据加载完成, room=', this.auditAuthOwnerUndoInfo.room, 'owners count=', this.auditAuthOwnerUndoInfo.owners.length)
      }
    },

    parseRemark(remark) {
      if (!remark) return
      const parts = remark.split('；')
      const baseUrl = getFileBaseUrl()
      const communityId = getCommunityId()
      const self = this
      parts.forEach(function(part) {
        if (part.startsWith('车位ID：')) {
          self.auditAuthOwnerUndoInfo.psId = part.replace('车位ID：', '')
        } else if (part.startsWith('车位描述：')) {
          self.auditAuthOwnerUndoInfo.psName = part.replace('车位描述：', '')
        } else if (part.startsWith('车牌号：')) {
          self.auditAuthOwnerUndoInfo.carNum = part.replace('车牌号：', '')
        } else if (part.startsWith('证明图片：')) {
          const fileIds = part.replace('证明图片：', '').split(',').filter(function(id) { return id })
          self.auditAuthOwnerUndoInfo.photoUrls = fileIds.map(function(fileId) {
            return baseUrl + '?fileId=' + fileId + '&communityId=' + communityId + '&time=' + Date.now()
          })
        } else if (part.startsWith('审核意见：')) {
          self.auditAuthOwnerUndoInfo.audit.remark = part.replace('审核意见：', '')
        }
      })
    },

    _updateCompareResult() {
      const r = this.auditAuthOwnerUndoInfo.room
      const owners = this.auditAuthOwnerUndoInfo.owners
      const appName = this.auditAuthOwnerUndoInfo.appUserName
      const appLink = this.auditAuthOwnerUndoInfo.link
      const appIdCard = this.auditAuthOwnerUndoInfo.idCard
      console.log('[audit] _updateCompareResult 开始 r.ownerName=', r && r.ownerName, 'owners count=', owners.length)

      const matchedOwner = owners.find(o => {
        if (appIdCard && o.idCard === appIdCard) return true
        if (appName && o.name === appName) return true
        if (appLink && o.link === appLink) return true
        return false
      })
      console.log('[audit] matchedOwner=', matchedOwner)

      const sysOwnerName = r && r.ownerName ? r.ownerName : (matchedOwner ? matchedOwner.name : null)
      const sysOwnerLink = r && r.link ? r.link : (matchedOwner ? matchedOwner.link : null)
      const sysOwnerIdCard = matchedOwner ? matchedOwner.idCard : null

      const result = {
        sysOwnerName: sysOwnerName || null,
        sysOwnerLink: sysOwnerLink || null,
        sysOwnerIdCard: sysOwnerIdCard || null,
        sysRoomName: r && r.roomName ? r.roomName : null,
        appRoomName: r && r.roomName ? r.roomName : '—',
        nameMatch: sysOwnerName ? (appName === sysOwnerName) : null,
        linkMatch: sysOwnerLink ? (appLink === sysOwnerLink) : null,
        idCardMatch: sysOwnerIdCard ? (appIdCard === sysOwnerIdCard) : null,
        roomMatch: r && r.roomName ? true : null
      }
      console.log('[audit] compareResult=', JSON.stringify(result))
      this.compareResult = result
      this.$forceUpdate()
    },

    onAuditStateChange(value) {
      if (value === '1100') {
        this.auditAuthOwnerUndoInfo.audit.remark = '同意'
      } else if (value === '1200' && this.auditAuthOwnerUndoInfo.audit.remark === '同意') {
        this.auditAuthOwnerUndoInfo.audit.remark = ''
      }
    },

    async auditSubmit() {
      try {
        if (!this.auditAuthOwnerUndoInfo.audit.state) {
          this.$message.warning('请选择审核结果')
          return
        }
        if (!this.auditAuthOwnerUndoInfo.audit.remark) {
          this.$message.warning('请填写审核说明')
          return
        }
        const auditInfo = {
          ...this.auditAuthOwnerUndoInfo.audit,
          communityId: getCommunityId()
        }
        const res = await auditAuthOwner(auditInfo)
        if (res.code !== 0) {
          this.$message.error(res.msg)
          return
        }
        this.$message.success('审核操作成功')
        this.$router.go(-1)
      } catch (error) {
        this.$message.error('提交失败: ' + error)
      }
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.audit-auth-owner-undo-container {
  padding: 20px;
  background: #f5f7fa;
  min-height: 100vh;

  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .header-left {
      display: flex;
      align-items: center;
      gap: 12px;

      .page-title {
        margin: 0;
        font-size: 20px;
        font-weight: 600;
        color: #303133;
      }
    }
  }

  .box-card {
    margin-bottom: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .card-title {
      font-size: 15px;
      font-weight: 600;
      color: #303133;

      i {
        margin-right: 6px;
        color: #409EFF;
      }
    }

    .card-tip {
      font-size: 12px;
      color: #909399;
    }
  }

  // 对比卡片
  .compare-card {
    border-left: 4px solid #409EFF;

    .compare-table {
      margin-bottom: -1px;
    }
  }

  .compare-label {
    font-weight: 600;
    color: #606266;
    font-size: 13px;
  }

  .compare-label-col {
    background: #f8f9fb;
  }

  .compare-app-col {
    background: #fdf6ec;
  }

  .compare-sys-col {
    background: #f2f6fc;
  }

  .compare-value {
    padding: 2px 4px;
    border-radius: 4px;
    font-weight: 500;
    position: relative;

    &.app-value {
      color: #e6a23c;
    }
    &.sys-value {
      color: #409EFF;
    }
    &.match {
      background: #e1f3d8;
    }
    &.mismatch {
      background: #fde2e2;
    }
  }

  .matched-icon {
    color: #67c23a;
    margin-left: 6px;
    font-weight: bold;
  }

  .mismatched-icon {
    color: #f56c6c;
    margin-left: 6px;
    font-weight: bold;
  }

  .text-muted {
    color: #c0c4cc;
  }
  .text-success {
    color: #67c23a;
  }
  .text-danger {
    color: #f56c6c;
  }
  .text-mono {
    font-family: 'Courier New', monospace;
    font-size: 12px;
    color: #909399;
  }

  // 信息项
  .info-item {
    padding: 12px 0;
    border-bottom: 1px solid #f0f0f0;

    .info-label {
      font-size: 12px;
      color: #909399;
      margin-bottom: 4px;
    }

    .info-value {
      font-size: 14px;
      color: #303133;
      font-weight: 500;

      &.highlight {
        color: #409EFF;
        font-size: 16px;
        font-weight: 700;
      }
    }
  }

  // 图片网格
  .photo-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 12px;

    .photo-item {
      width: 100%;
      height: 140px;
      border-radius: 8px;
      border: 1px solid #e8e8e8;
      cursor: pointer;
      transition: transform 0.2s;

      &:hover {
        transform: scale(1.03);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }
    }
  }

  // 审核卡片
  .audit-card {
    border-left: 4px solid #e6a23c;
  }

  // 审核结果卡片
  .audit-result-card {
    border-left: 4px solid #67c23a;

    .audit-result {
      padding: 20px 0;

      .result-status {
        display: flex;
        align-items: center;
        gap: 20px;

        .result-icon {
          font-size: 48px;

          &.success {
            color: #67c23a;
          }
          &.fail {
            color: #f56c6c;
          }
        }

        .result-text {
          h3 {
            margin: 0 0 8px 0;
            font-size: 18px;
            color: #303133;
          }
          .result-remark {
            margin: 0;
            color: #909399;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
